package gr.tech.GRAttestation.models.storeusers

import kotlinx.serialization.Serializable

@Serializable
data class StoreAddUsersRequest(
    val email: String?,
    val storeId: Int,
    val notes: String,
)

@Serializable
data class SendInviteEmailRequest(
    val sendToEmail: String,
)